import { NgModule } from '@angular/core';
import { Dashlib2Component } from './dashlib2.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [Dashlib2Component],
  imports: [FormsModule,
    ReactiveFormsModule,
  ],
  exports: [Dashlib2Component]
})
export class Dashlib2Module { }
